<div
    class="mx-auto flex max-w-1264 flex-col md:grid md:grid-cols-2 md:px-24 md:pt-40 md:pb-80 lg:flex lg:gap-56"
    [ngClass]="{
        'lg:flex-row-reverse': !imageLeft(),
        'lg:flex-row': imageLeft(),
    }"
>
    <div class="relative h-full grow">
        <ui-m000-c010-image
            class="relative block h-full"
            [classList]="
                `h-full w-full aspect-[766/432] md:aspect-[4/3] lg:aspect-[686/385] ${imageContains()}`
                    ? 'object-contain'
                    : 'object-cover'
            "
            [image]="{
                image: image(),
                desktop: { width: 686, height: 385 },
                tablet: { width: 608, height: 456 },
                mobile: { width: 766, height: 432 },
            }"
            [priority]="isFirstView()"
            [alt]="imageAlt() ?? 'Default Teaser Image'"
            [cover]="!imageContains()"
            [contain]="imageContains()"
            [highRes]="true"
        />
        <ng-content select="[imageEdit]" />
    </div>
    <div
        class="flex flex-col items-start justify-center px-24 pt-24 pb-40 lg:max-w-530 lg:justify-start lg:pt-0 lg:pb-24"
    >
        <div
            class="font-headline text-24 md:text-34 mb-12 leading-28 font-medium text-black empty:hidden md:leading-41"
        >
            <ng-content select="[headline]" />
        </div>

        <div class="font-headline text-16 mb-12 leading-27 font-medium text-black empty:hidden lg:hidden">
            <ng-content select="[mobileSubheadline]" />
        </div>

        <div class="w-full">
            @if (list()) {
                <div class="flex">
                    <div class="mt-12 flex flex-col gap-12">
                        @for (item of list(); track $index) {
                            <div class="flex items-center gap-12">
                                <i class="text-40 text-black" [ngClass]="[item.icon]"></i>
                                <p class="text-16 leading-27 text-black">{{ item.text }}</p>
                            </div>
                        }
                    </div>
                    <ng-content select="[benefitsEdit]" />
                </div>
            }

            <p class="text-16 leading-27 wrap-break-word whitespace-pre-line text-black empty:hidden">
                <ng-content select="[text]" />
            </p>

            <div class="mt-24 inline-flex w-full justify-between gap-20 empty:hidden">
                <ng-content select="[cta]" />

                <ng-content select="[secondaryCta]" />
            </div>
        </div>
    </div>
</div>
